import styled from 'styled-components';
import background from '../../assets/home/background-bacve.jpg'
import { colors } from "../../utils/colors";

export const Background = styled.div`
    position: relative;
    width: 100%;
    min-height: 100vh;
    background: url(${background});
    background-repeat: no-repeat;
    background-size: cover;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
`;

export const TitleDiv = styled.div`
    position: absolute;
    top: 100px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
`;

export const Subtitle = styled.h2`
    color: white;
    font-family: 'Courgette', cursive;
    margin-bottom: 20px;
    text-align: center;
`;

export const Text = styled.p`
    color: ${(props) => props.blue ? colors.DARK_BLUE : colors.CREAM};
    margin-bottom: ${(props) => props.top ? '5px' : '30px'};
    text-align: center;
    font-size: ${(props) => props.shop ? '22px' : 'auto'};
`;

export const SplitDiv = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    margin: 5% 0 0 0;
    padding: 0 60px;

    @media (max-width: 1200px) {
        flex-direction: column;
        padding: 0 40px;
    }

    @media (max-width: 800px) {
        padding: 0 20px;
    }

    @media (max-width: 380px) {
        margin-top: 180px;
        padding-bottom: 40px;
    }
`;

export const FiftyPercent = styled.div`
    width: 50%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;

    @media (max-width: 1200px) {
        width: 100%;
    }
`;

export const MediaWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
`;

export const MediaLink = styled.img`
    width: 30px;
`;

export const HeaderImg = styled.img`
    position: absolute;
    left: 15%;
    bottom: %;
    width: 50%;

    @media (max-width: 1200px) {
        display: none;
    }
`;

export const HeaderTextWrapper = styled.div`
    width: 67%;

    @media (max-width: 1200px) {
        width: 80%;
    }
`;

export const HeaderTextUpper = styled.p`
    color: white;
    text-transform: uppercase;
    letter-spacing: 2px;
    margin-bottom: 5px;
`;

export const HeaderTextTittle = styled.h2`
    color: white;
`;

export const HeaderTextButtonWrapper = styled.div`
    display: flex;

    @media (max-width: 400px) {
        flex-direction: column;
    }
`;

export const HeaderTextButton = styled.button`
    border: 2px solid ${(props) => props.red ? colors.RED : colors.CREAM};
    margin: ${(props) => props.right ? '15px 0 15px 0' : props.red ? '0 0 0 0': '15px 10px 15px 0'};
    padding: 5px 10px;
    background: ${(props) => props.cream ? colors.CREAM : 'transparent'};
    border-radius: 5px;
    color: ${(props) => props.cream ? colors.BLUE : props.red ? colors.RED : 'white'};
    transition: 200ms cubic-bezier(0.4, 0, 0.2, 1);
    text-transform: uppercase;
    box-shadow: 0 3px 3px -2px rgba(0,0,0,.2),
                0 3px 4px 0 rgba(0,0,0,.14),
                0 1px 8px 0 rgba(0,0,0,.12);

    &:hover {
        cursor: pointer;
        border: 2px solid ${(props) => props.red ? colors.RED : colors.BLUE};
        background: ${colors.CREAM};
    }
`;

export const ClickMap = styled.map`
    height: 9vw;
    width: 9vw;
    position: relative;
    right: -45.8%;
    top: 8.7vw;

    @media (max-width: 2000px) {
        height: 8.8vw;
        width: 8.8vw;
        right: -45.9%;
        top: 8.5vw;
    }

    @media (max-width: 1500px) {
        top: 8.3vw;
        right: -45.7%;
    }

    @media (max-width: 1200px) {
        display: none;
    }
`;